var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMolot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34 17.156h8.333c.458 0 .833.375.833.833a.836.836 0 0 1-.833.833H2.34a.836.836 0 0 1-.834-.833c0-.458.375-.833.834-.833zM5.04 6.38l2.358-2.359 10.608 10.609c.65.65.65 1.708 0 2.358s-1.708.65-2.358 0zm7.075-4.717 2.358 2.358c.65.65.65 1.709 0 2.359L13.29 7.564 8.58 2.847l1.175-1.175a1.662 1.662 0 0 1 2.359-.008zm-8.25 5.892 4.716 4.716-1.175 1.175a1.67 1.67 0 0 1-2.358 0L2.69 11.09a1.67 1.67 0 0 1 0-2.358z",
    fill: "#e31a87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolot);
export default __webpack_public_path__ + "static/media/molot.ae0ee8597a5e47942d2d88719328dd99.svg";
export { ForwardRef as ReactComponent };